/* registerServiceWorker.js */
if ('serviceWorker' in navigator) {
  let refreshing = false;

  // Quando um novo Service Worker assumir o controle, recarrega a página uma vez
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  navigator.serviceWorker
    .register('/service-worker.js')
    .then((registration) => {
      // Se já existir um SW em estado "waiting", ativa imediatamente
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Quando o build novo for encontrado, força o SW novo a assumir
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    })
    .catch((err) => {
      console.error('Erro ao registrar service worker:', err);
    });
}
